import React, { useRef, useState } from 'react';
import { Checkbox, FormControlLabel, FormHelperText, FormControl, useTheme } from '@mui/material';
import { Controller } from 'react-hook-form';
import { generateTestId } from 'app/functions';
import HtmlContent from 'components/html/HtmlContent';
import { useSelector } from 'react-redux';

export const HotCheckbox = ({
  name,
  control,
  label,
  required = false,
  helperText,
  linksNotClickedErrorText,
  rules = {},
  sx,
  testID,
  ...rest
}) => {
  const htmlContentRef = useRef();
  const [linksStatus, setLinksStatus] = useState({ isComplete: true, totalLinks: 0 });
  const text = useSelector((state) => state.config.Translations);
  const [fieldError, setFieldError] = useState('');
  const [status, setStatus] = useState({});
  const theme = useTheme();

  // If required is true, add it to the rules
  if (required && !rules.required) {
    rules.required = 'This field is required';
  }

  const customRules = {
    ...rules,
    validate: {
      ...(rules.validate || {}),
      linksClicked: (value) => {
        if (!value) return true;
        
        return linksStatus.isComplete || linksNotClickedErrorText || text['agreement_link_not_clicked_error'];
      }
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={customRules}
      render={({ field: { value, onChange, ...field }, fieldState: { error } }) => (
        <React.Fragment>
        <FormControl error={!!fieldError || !!error} required={required}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            flexDirection: "row",
          }}
        >
          <FormControlLabel
            sx={sx}
            control={
              <Checkbox
                testid={generateTestId(testID, `${name}-checkbox`)}
                checked={!!value}
                onChange={(e) => {
                  
                  if (!linksStatus.isComplete) {
                    setFieldError(linksNotClickedErrorText || text['agreement_link_not_clicked_error']);                    
                  }else{
                    onChange(e.target.checked);
                  }                  
                }}
                {...field}
                {...rest}
              />
            }
          />
          <HtmlContent 
                className='hot-checkbox-label'
                ref={htmlContentRef}
                content={label || ''}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onLinkStatusChange={(status) => {
                  setStatus(status);

                  const clickedAllLinks = status.clickedLinks.length === status.allLinks.length
                  setLinksStatus({...status, isComplete: clickedAllLinks});
                  
                  if (status.isComplete){
                    setFieldError(error?.message || '');   
                  }
                }}
              />
        </FormControl>
        <FormHelperText 
            sx={{
              marginTop: "-5px",
              minHeight: "1rem",
              color: theme.palette.text.error,
              fontSize: "0.75rem",
              visibility: (!!error?.message || fieldError ||  helperText || (value && linksStatus.totalLinks > 0 && !linksStatus.isComplete)) ? 'visible' : 'hidden'
            }}
          >
            { fieldError || error?.message || helperText || ' ' }
          </FormHelperText>
        </React.Fragment>
      )}
    />
  );
};

export default HotCheckbox; 